import { render, staticRenderFns } from "./PointsRemaining.vue?vue&type=template&id=347459ec&scoped=true&"
import script from "./PointsRemaining.vue?vue&type=script&lang=js&"
export * from "./PointsRemaining.vue?vue&type=script&lang=js&"
import style0 from "./PointsRemaining.vue?vue&type=style&index=0&id=347459ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347459ec",
  null
  
)

export default component.exports